import './projectListItem.scss';
import { Link } from 'gatsby';
import * as React from 'react';
import { icons } from '../../content/icons';
import { RoutePaths } from '../../routes';
import { ColourUtils } from '../../utils/colours';
import { ImageUtils } from '../../utils/image';
import { RMButton } from '../layout/rmButton';
import { SplitPane } from '../layout/splitPane';
import { LazyCosmosImage } from '../media/cosmosImage';
import Quote from '../quotes/quote';
import ProjectTags from './projectTags';
export const ProjectListItem = ({ project }) => {
    const backgroundColourStyle = React.useMemo(
    // () => ({ ...backgroundColourWithColouredShadow(project.client_brand_color, true) }),
    () => ({ backgroundColor: project.client_brand_color }), []);
    const id = project.client_name.replace(/ /g, '-');
    return (<div className="project-list-item-wrapper" id={id}>
      <Link to={RoutePaths.projects.project(project)}>
        <SplitPane className="project-list-item" style={backgroundColourStyle} rightProps={{ className: 'project-list-item-info-wrapper' }} right={<>
              <div className="project-list-item-info">
                <h3>{project.client_name}</h3>
                {project.strapline && <p className="project-strapline">{project.strapline}</p>}

                <p className="project-description">{project.project_description_short}</p>

                {project.project_types && project.project_types.length > 0 && <ProjectTags tags={project.project_types}/>}

                <RMButton name={`more on ${project.client_name}`} rightIcon={icons.right} variant="lighten-bg">
                  More info
                </RMButton>
              </div>
            </>} leftProps={{ className: 'project-mockup' }} left={<>
              <LazyCosmosImage alt={`${project.client_name} mockup`} ticket={project.project_transparent_bg_mockup[0].ticket} size={ImageUtils.imageSizes.medium}/>
            </>}/>

        {project.project_quote.quote_text && (<Quote quoteText={project.project_quote.quote_text} author={{
        name: project.project_quote.author_name,
        position: project.project_quote.author_position,
    }} image={{
        alt: project.project_quote.author_photo[0].fileName,
        ticket: project.project_quote.author_photo[0].ticket,
    }}/>)}
      </Link>

      <ColourUtils.SelectionColourChange colour={project.client_brand_color} selector={`.project-list-item-wrapper#${id} *`}/>
    </div>);
};
